module.exports = __webpack_public_path__ + "static/media/Websites.a23bb901.jpg";